export default __webpack_public_path__ + "static/media/service1-min.a7b69cdd.png";